import {handleRepositoryDataError} from '@github-ui/data-router-error-helpers'
import {IssueNewContent} from '@github-ui/issues-shared/IssueNewContent'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports -- Transitional: the duplicate-detection preheat still uses useRelayEnvironment; removed when issue-viewer leaves Relay.
import {relayEnvironmentWithMissingFieldHandlerForNode, RelayEnvironmentProvider} from '@github-ui/relay-environment'
import {AnalyticsWrapper as BaseAnalyticsWrapper} from '@github-ui/repo-issues-page-layout/AnalyticsWrapper'
import {UserContext} from '@github-ui/use-user'
import {useMemo} from 'react'

import {issueNewRoute} from './issue-new-route'
import {issuesLayoutRoute, layoutCurrentUser} from './issues-layout-route'

export function IssueNew() {
  const payload = useRouteQuery(issueNewRoute, 'mainQuery')
  const layoutPayload = useRouteQuery(issuesLayoutRoute, 'mainQuery')
  const currentUserSettings = layoutPayload.data?.currentUserSettings
  const currentUser = layoutCurrentUser(layoutPayload.data)

  // IssueNewContent's duplicate-detection preheat calls useRelayEnvironment() but the
  // data-router issues app has no Relay provider, so supply a local one (the MilestoneEdit pattern).
  const relayEnvironment = useMemo(() => relayEnvironmentWithMissingFieldHandlerForNode(), [])

  // FORBIDDEN/SAML reloads the page; other errors throw to the boundary.
  const data = handleRepositoryDataError(payload.data)
  if (!data?.repository) {
    return null
  }

  // The create form owns its own chrome, so this leaf skips RepoIssuesPageLayout.
  return (
    <BaseAnalyticsWrapper category="Repository Issue Create" appName="issues">
      <RelayEnvironmentProvider environment={relayEnvironment}>
        {/* IssueCreatePage reads the viewer via useUser(), which has no app payload to fall back on here. */}
        <UserContext value={currentUser}>
          <IssueNewContent
            repository={data.repository}
            currentUserSettings={
              currentUserSettings
                ? {
                    preferred_emoji_skin_tone: currentUserSettings.preferredEmojiSkinTone,
                    copilot_show_functionality: currentUserSettings.copilotShowFunctionality,
                  }
                : undefined
            }
            duplicateDetectionEnabled={payload.data?.semantic_similarity_duplicate_issue_detection}
          />
        </UserContext>
      </RelayEnvironmentProvider>
    </BaseAnalyticsWrapper>
  )
}
